import { createContext, useContext } from 'react';

import ClientLogger from '~logger/client';
import { LoggerMessages, LoggerServices } from '~logger/constants';

import type { AccountContextValue } from './types';

export const AccountContext = createContext<AccountContextValue>({
	balance: 0,
	hasSubscription: false,
	loading: true,
	isSuccess: false,
});

export const useAccountContext = () => {
	const context = useContext(AccountContext);
	if (!context) {
		ClientLogger.error(
			LoggerServices.PaymentService,
			LoggerMessages.PaymentContextError,
			{}
		);
		throw Error('AccountContext no context Provider');
	}
	return context;
};
